import { Box, Stack } from '@mui/material';
import { Widget } from '@procureai/ui-mui';
import { ReactNode } from 'react';

import { SvbrgChatMessageRole } from '@/generated/gql/graphql';

import { ChatActions } from './ChatActions/ChatActions';
import { ChatAvatar } from './ChatAvatar/ChatAvatar';
import { ChatMessage, LoaderVariantType } from './ChatMessage/ChatMessage';
import { ChatTitle } from './ChatTitle/ChatTitle';

interface ChatMessageProps {
  createdBy: string;
  role: SvbrgChatMessageRole;
  message: string | ReactNode;
  messageLoader?: LoaderVariantType;
}

interface ChatStepProps extends ChatMessageProps {
  title: string | ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
}

export const ChatStep = ({
  title,
  role,
  createdBy,
  message,
  messageLoader = 'none',
  children,
  footer,
}: ChatStepProps) => {
  return (
    <Stack direction="row" spacing={2}>
      <ChatAvatar role={role} createdBy={createdBy} sx={{ display: { xs: 'none', md: 'block' } }} />
      <Widget>
        <Stack
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: 3,
          }}
        >
          <ChatTitle>{title}</ChatTitle>
          <ChatMessage loaderVariant={messageLoader}>{message}</ChatMessage>
          <Box sx={{ marginTop: 3, marginBottom: 4 }}>{children}</Box>
          {footer && <ChatActions>{footer}</ChatActions>}
        </Stack>
      </Widget>
    </Stack>
  );
};
